module.exports = __webpack_public_path__ + "img/faq-illustrations.06fc90e5.svg";